// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/contacts/empty-plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/icons/contacts/empty-file.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   CONTACTS PAGE — FIGMA SPEC IMPLEMENTATION
   Figma Node ID: 1564:171361 (Contact-flow)
   - Desktop Light: 1529:154295 ("Maple Electrical — Contacts Filters Light")
   - Contacts Default: 1564:171670 ("Maple Electrical — Contacts Light")
   - Filters Popover: 1529:154228 ("Contacts Filters — Popover")
   - Delete Confirmation: 1591:150817
   - Empty State: 1595:152030
   - Search No Results: 1595:152485
   ========================================================================== */

/* --------------------------------------------------------------------------
   Root Container & Variables
   -------------------------------------------------------------------------- */
.contacts-page {
  --dash-bg: var(--bg-primary, #f4f7f7);
  --dash-surface: var(--surface-primary, #ffffff);
  --dash-surface-2: var(--surface-secondary, #f4f7f7);
  --dash-surface-3: var(--surface-tertiary, #e8edec);
  --dash-border: var(--border-subtle, #dce3e2);
  --dash-border-strong: var(--border-default, #cdd6d4);
  --dash-text: var(--text-primary, #142624);
  --dash-muted: var(--text-secondary, #506360);
  --dash-tertiary: var(--text-tertiary, #6b7b78);
  --dash-brand: var(--interactive-default, #0f766e);
  --interactive-default: #0f766e;
  --interactive-hover: #0a655f;
  --interactive-pressed: #084f4b;
  --interactive-soft: #f0f8f7;
  --on-interactive-primary: #ffffff;
  --text-link: #0f766e;
  --success-soft: #edfbf2;
  --success-text: #115a33;
  --danger-soft: #fef2f1;
  --danger-text: #a3301f;
  --font-family-primary: "Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, sans-serif;
  --font-family-mono: "JetBrains Mono", monospace;

  min-height: 100vh;
  display: flex;
  background: var(--dash-bg);
  color: var(--dash-text);
  font-family: var(--font-family-primary);
  font-size: 13px;
  line-height: 1.4;
  position: relative;
}

.contacts-page.dark,
.contacts-page[data-theme="dark"] {
  --dash-bg: #101113;
  --dash-surface: #191b1f;
  --dash-surface-2: #22252a;
  --dash-surface-3: #2b2f35;
  --dash-border: #2c3036;
  --dash-border-strong: #3a3f47;
  --dash-text: #f2f3f5;
  --dash-muted: #b3b8c2;
  --dash-tertiary: #8a9896;
  --dash-brand: #43a79c;
  --interactive-default: #43a79c;
  --interactive-hover: #83c7be;
  --interactive-pressed: #b6ded8;
  --interactive-soft: #22252a;
  --on-interactive-primary: #101113;
  --text-link: #83c7be;
  --success-soft: #1b332b;
  --success-text: #8cd2b2;
  --danger-soft: #382324;
  --danger-text: #f3a6a1;
}

.contacts-page *,
.contacts-page *::before,
.contacts-page *::after {
  box-sizing: border-box;
}

/* --------------------------------------------------------------------------
   Layout Shell
   -------------------------------------------------------------------------- */
.contacts-page .dashboard-main {
  flex: 1 1;
  min-width: 0;
  margin-left: 256px;
  display: flex;
  flex-direction: column;
}

.contacts-content {
  width: 100%;
  min-height: calc(100vh - 64px);
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 32px 32px 48px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* --------------------------------------------------------------------------
   Page Header (Figma 1529:154312)
   -------------------------------------------------------------------------- */
.contacts-page-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contacts-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.contacts-page-identity {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.contacts-page-identity h1 {
  font-family: var(--font-family-primary);
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
  color: var(--dash-text);
  margin: 0;
}

.contacts-page-identity p {
  font-family: var(--font-family-primary);
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  color: var(--dash-muted);
  margin: 0;
}

.contacts-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.contacts-page .contacts-import-btn {
  height: 40px;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.15s ease;
  text-decoration: none;
  white-space: nowrap;
}

.contacts-page .contacts-import-btn:hover {
  background: var(--surface-tertiary, #e8edec);
  border-color: var(--border-strong, #8b9996);
  color: var(--text-primary, #142624);
}

.contacts-page .contacts-import-btn:focus-visible {
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: 2px;
}

.contacts-create-btn,
.contacts-create-btn:link,
.contacts-create-btn:visited {
  height: 40px;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  border: none;
  background: var(--interactive-default, #0f766e);
  color: #ffffff !important;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
  text-decoration: none;
  white-space: nowrap;
}

.contacts-create-btn:hover {
  background: var(--interactive-hover, #0a655f);
  color: #ffffff !important;
}

.contacts-create-btn:active {
  background: var(--interactive-pressed, #084f4b);
  color: #ffffff !important;
}

.contacts-create-btn:focus-visible {
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: 2px;
}

.contacts-create-btn svg {
  width: 16px;
  height: 16px;
  font-size: 16px;
  flex-shrink: 0;
  stroke-width: 2.25;
  color: #ffffff !important;
  stroke: #ffffff !important;
  fill: none;
}

/* Dark mode styling matching Quotations and Project Theme */
.contacts-page.dark .contacts-create-btn,
.contacts-page[data-theme="dark"] .contacts-create-btn {
  background: var(--interactive-default, #43a79c);
  color: #101113 !important;
  font-weight: 600;
}

.contacts-page.dark .contacts-create-btn svg,
.contacts-page[data-theme="dark"] .contacts-create-btn svg {
  color: #101113 !important;
  stroke: #101113 !important;
}

.contacts-page.dark .contacts-create-btn:hover,
.contacts-page[data-theme="dark"] .contacts-create-btn:hover {
  background: var(--interactive-hover, #83c7be);
  color: #101113 !important;
}

.contacts-page.dark .contacts-create-btn:active,
.contacts-page[data-theme="dark"] .contacts-create-btn:active {
  background: var(--interactive-pressed, #b6ded8);
  color: #101113 !important;
}

.contacts-page.dark .contacts-import-btn {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.contacts-page.dark .contacts-import-btn:hover,
.contacts-page[data-theme="dark"] .contacts-import-btn:hover {
  background: var(--surface-tertiary, #2b2f35);
  border-color: var(--border-strong, #69727e);
  color: var(--text-primary, #f2f3f5);
}

.contacts-statement-btn {
  height: 40px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid var(--dash-border-strong);
  background: var(--dash-surface);
  color: var(--dash-text);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.15s ease;
}

.contacts-statement-btn:hover {
  background: var(--surface-tertiary, #e8edec);
  border-color: var(--border-strong, #8b9996);
  color: var(--text-primary, #142624);
}

.contacts-page.dark .contacts-statement-btn:hover,
.contacts-page[data-theme="dark"] .contacts-statement-btn:hover {
  background: var(--surface-tertiary, #2b2f35);
  border-color: var(--border-strong, #69727e);
  color: var(--text-primary, #f2f3f5);
}

.contacts-statement-btn.active {
  background: var(--interactive-soft);
  color: var(--text-link);
  border-color: var(--interactive-default);
}

/* --------------------------------------------------------------------------
   Contact Filters & Tabs (Figma 1529:154321)
   -------------------------------------------------------------------------- */
.contacts-filter-section {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

.contacts-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid var(--dash-border);
  width: 100%;
}

.contacts-tab {
  height: 40px;
  padding: 0 12px;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  color: var(--dash-muted);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: -1px;
  transition: all 0.15s ease;
}

.contacts-tab:hover {
  color: var(--dash-text);
}

.contacts-tab.active {
  color: var(--text-link);
  border-bottom-color: var(--interactive-default);
}

/* --------------------------------------------------------------------------
   Search & Filter Controls Row (Figma 1529:154329)
   -------------------------------------------------------------------------- */
.contacts-controls-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.contacts-controls-row .contacts-register-filter {
  flex: 0 0 auto;
  width: max-content;
  max-width: 100%;
}

.contacts-controls-row .contacts-clear-filters {
  flex-shrink: 0;
  white-space: nowrap;
}

.contacts-search-box {
  width: 320px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid var(--dash-border);
  background: var(--dash-surface);
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 8px;
  transition: border-color 0.15s ease;
}

.contacts-search-box:focus-within {
  border-color: var(--interactive-default);
}

.contacts-search-icon {
  font-size: 16px;
  color: var(--dash-tertiary);
  flex-shrink: 0;
}

.contacts-search-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: var(--font-family-primary);
  font-size: 14px;
  color: var(--dash-text);
}

.contacts-search-input::placeholder {
  color: var(--dash-tertiary);
}

.contacts-search-clear {
  border: none;
  background: transparent;
  color: var(--dash-tertiary);
  cursor: pointer;
  padding: 2px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.contacts-search-clear:hover {
  color: var(--dash-text);
}

.contacts-filter-btn {
  height: 40px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid var(--dash-border-strong);
  background: var(--dash-surface);
  color: var(--dash-text);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.15s ease;
  position: relative;
}

.contacts-filter-btn:hover {
  background: var(--dash-surface-2);
  border-color: var(--dash-muted);
}

.contacts-filter-btn.active {
  border-color: var(--interactive-default);
  color: var(--text-link);
  background: var(--interactive-soft);
}

.contacts-filter-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--interactive-default);
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  margin-left: 2px;
}

/* --------------------------------------------------------------------------
   Contacts Table Card (Figma 1529:154332)
   -------------------------------------------------------------------------- */
.contacts-table-card {
  width: 100%;
  background: var(--dash-surface);
  border: 1px solid var(--dash-border);
  border-radius: 14px;
  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.contacts-table-card.is-empty {
  flex: 1 1;
  min-height: 320px;
}

.contacts-table-context {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid var(--dash-border);
}

.contacts-table-count {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.065px;
  color: var(--dash-text);
}

.contacts-table-scope {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  color: var(--dash-muted);
}

.contacts-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.contacts-table {
  width: 100%;
  min-width: 1050px;
  border-collapse: collapse;
  table-layout: fixed;
  text-align: left;
}

/* Table Headings */
.contacts-thead tr {
  height: 44px;
  background: var(--dash-surface-2);
  border-bottom: 1px solid var(--dash-border);
}

.contacts-th {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.065px;
  color: var(--dash-muted);
  padding: 0 12px;
  white-space: nowrap;
}

.contacts-th.th-name {
  width: 32%;
  min-width: 220px;
}

.contacts-th.th-contact {
  width: 26%;
  min-width: 200px;
}

.contacts-th.th-abn {
  width: 146px;
  min-width: 130px;
}

.contacts-th.th-terms {
  width: 100px;
  min-width: 90px;
}

.contacts-th.th-reminders {
  width: 96px;
  min-width: 90px;
}

.contacts-th.th-balance {
  width: 140px;
  min-width: 120px;
  text-align: right;
}

.contacts-th.th-actions,
.contacts-td.td-actions {
  width: 64px;
  min-width: 64px;
  max-width: 64px;
  text-align: center;
  padding: 0 8px;
}

/* Table Rows */
.contacts-tbody tr {
  height: 64px;
  border-bottom: 1px solid var(--dash-border);
  transition: background-color 0.15s ease;
}

.contacts-tbody tr:hover {
  background-color: var(--dash-surface-2);
}

.contacts-tbody .app-skeleton-tr td {
  padding: 8px 12px;
  vertical-align: middle;
}

.contacts-clickable-row {
  cursor: pointer;
}

.contacts-clickable-row:focus-visible {
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: -2px;
}

.contacts-td {
  padding: 8px 12px;
  vertical-align: middle;
}

/* Name Cell */
.contacts-name-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.contacts-avatar {
  width: 28px;
  height: 28px;
  border-radius: 12px;
  background: var(--interactive-soft);
  border: 1.5px solid var(--dash-border);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-family: var(--font-family-primary);
  font-size: 10px;
  font-weight: 600;
  color: var(--interactive-default);
  text-transform: uppercase;
}

.contacts-name-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.contacts-company-link {
  text-decoration: none;
  color: inherit;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contacts-company-link:hover .contacts-company-name {
  color: var(--interactive-default, #0f766e);
  text-decoration: underline;
}

.contacts-company-name {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  color: var(--dash-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.15s ease;
}

.contacts-type-sub {
  font-family: var(--font-family-primary);
  font-size: 11px;
  font-weight: 400;
  color: var(--dash-muted);
}

/* Contact Person Cell */
.contacts-contact-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.contacts-contact-name {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  color: var(--dash-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contacts-contact-email {
  font-family: var(--font-family-primary);
  font-size: 11px;
  font-weight: 400;
  color: var(--dash-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ABN & Terms */
.contacts-abn-text,
.contacts-terms-text {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  color: var(--dash-text);
  white-space: nowrap;
}

/* Reminder Status Pill */
.contacts-reminder-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-family: var(--font-family-primary);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.11px;
}

.contacts-reminder-pill.pill-on {
  background: var(--success-soft);
  color: var(--success-text);
}

.contacts-reminder-pill.pill-off {
  background: var(--danger-soft);
  color: var(--danger-text);
}

/* Open Balance */
.contacts-balance-cell {
  font-family: var(--font-family-mono);
  font-size: 14px;
  font-weight: 500;
  color: var(--dash-text);
  text-align: right;
  white-space: nowrap;
}

/* Actions Menu */
.contacts-actions-cell {
  text-align: center;
  position: relative;
}

.contacts-action-trigger {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: var(--dash-muted);
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.contacts-action-trigger:hover {
  background: var(--dash-surface-2);
  color: var(--dash-text);
}

.contacts-menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 100;
  min-width: 160px;
  background: var(--dash-surface);
  border: 1px solid var(--dash-border);
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(14, 26, 32, 0.12);
  padding: 4px;
  display: flex;
  flex-direction: column;
}

.contacts-menu-item {
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: var(--dash-text);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  text-align: left;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.1s ease;
  text-decoration: none;
}

.contacts-menu-item:hover {
  background: var(--dash-surface-2);
}

.contacts-menu-item.delete {
  color: var(--danger-text);
}

.contacts-menu-item.delete:hover {
  background: var(--danger-soft);
}

/* --------------------------------------------------------------------------
   Table Pagination (Figma 1529:154479)
   -------------------------------------------------------------------------- */
.contacts-pagination {
  height: 52px;
  background: var(--dash-surface);
  border-top: 1px solid var(--dash-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.contacts-pagination-info {
  font-family: var(--font-family-primary);
  font-size: 13px;
  color: var(--dash-muted);
}

.contacts-pagination.is-loading {
  visibility: hidden;
}

.contacts-pagination-nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.contacts-page-btn {
  width: 32px;
  height: 32px;
  border: 1px solid var(--dash-border-strong);
  border-radius: 6px;
  background: var(--dash-surface);
  color: var(--dash-text);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
}

.contacts-page-btn:hover:not(:disabled) {
  background: var(--dash-surface-2);
  border-color: var(--dash-muted);
}

.contacts-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* --------------------------------------------------------------------------
   Empty & Search No Results States (Figma 1595:152030 & 1595:152485)
   -------------------------------------------------------------------------- */
.contacts-empty-state {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 32px;
  text-align: center;
}

.contacts-empty-icon {
  width: 60px;
  height: 60px;
  border-radius: var(--radius-full, 9999px);
  background: var(--interactive-soft);
  color: var(--interactive-default);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 60px;
  overflow: hidden;
}

.contacts-empty-state--noResults .contacts-empty-icon {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-tertiary, #6b7b78);
}

.contacts-empty-icon__asset {
  width: 36px;
  height: 36px;
  background-color: currentColor;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: 36px 36px;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 36px 36px;
}

.contacts-empty-icon__asset.is-plus {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.contacts-empty-icon__asset.is-file {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.contacts-empty-copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: min(280px, 100%);
}

.contacts-empty-title {
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  color: var(--dash-text);
  width: 100%;
  margin: 0;
}

.contacts-empty-desc {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: var(--dash-muted);
  width: 100%;
  margin: 0;
}

.contacts-empty-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
}

.contacts-empty-primary,
.contacts-empty-primary:link,
.contacts-empty-primary:visited,
.contacts-empty-secondary,
.contacts-empty-secondary:link,
.contacts-empty-secondary:visited {
  height: 32px;
  padding: 0 12px;
  border-radius: var(--radius-md, 10px);
  border: 0;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  text-decoration: none;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.contacts-empty-primary,
.contacts-empty-primary:link,
.contacts-empty-primary:visited {
  background: var(--interactive-default);
  color: var(--on-interactive-primary) !important;
}

.contacts-empty-primary:hover {
  background: var(--interactive-hover);
  color: var(--on-interactive-primary) !important;
}

.contacts-empty-primary:active {
  background: var(--interactive-pressed);
}

.contacts-empty-secondary,
.contacts-empty-secondary:link,
.contacts-empty-secondary:visited {
  background: transparent;
  color: var(--interactive-default);
}

.contacts-empty-secondary:hover {
  background: var(--interactive-soft);
  color: var(--interactive-hover);
}

.contacts-empty-primary:focus-visible,
.contacts-empty-secondary:focus-visible {
  outline: 2px solid var(--focus-ring, var(--interactive-default));
  outline-offset: 2px;
}

/* --------------------------------------------------------------------------
   Filters Drawer / Popover (Figma 1529:154228)
   -------------------------------------------------------------------------- */
.contacts-filter-scrim {
  position: fixed;
  inset: 0;
  background: rgba(14, 26, 32, 0.4);
  z-index: 998;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.contacts-filter-scrim.open {
  opacity: 1;
  pointer-events: auto;
}

.contacts-filter-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 320px;
  background: var(--dash-surface);
  border-left: 1px solid var(--dash-border);
  box-shadow: -4px 0 24px rgba(14, 26, 32, 0.1);
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 20px;
  transform: translateX(100%);
  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  overflow-y: auto;
}

.contacts-filter-drawer.open {
  transform: translateX(0);
}

.contacts-controls-row .contacts-register-filter .quotation-figma-dropdown-trigger {
  box-sizing: border-box;
  height: 40px;
  border-width: 1px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 500;
}

.contacts-page > .catalogue-modal-menu-popper .quotation-figma-dropdown-option {
  height: auto;
  min-height: 36px;
  padding: 8px 10px;
  text-align: left;
  font: 400 13px/20px var(--font-family-primary);
}

.contacts-filter-drawer .quotation-clear-filters-btn {
  flex-shrink: 0;
  white-space: nowrap;
}

.contacts-drawer-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contacts-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}

.contacts-drawer-title {
  font-family: var(--font-family-primary);
  font-size: 18px;
  font-weight: 500;
  letter-spacing: -0.22px;
  color: var(--dash-text);
  margin: 0;
}

.contacts-drawer-clear {
  border: none;
  background: transparent;
  color: var(--text-link);
  font-family: var(--font-family-primary);
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  padding: 0;
}

.contacts-drawer-clear:hover {
  text-decoration: underline;
}

.contacts-filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contacts-group-title {
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.07px;
  color: var(--dash-text);
  margin: 0;
}

.contacts-radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 24px;
  cursor: pointer;
  font-family: var(--font-family-primary);
  font-size: 12px;
  color: var(--dash-text);
  -webkit-user-select: none;
          user-select: none;
}

.contacts-radio {
  appearance: none;
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border: 1.5px solid var(--dash-border-strong);
  border-radius: 50%;
  outline: none;
  cursor: pointer;
  display: grid;
  place-content: center;
  background-color: var(--dash-surface);
  transition: all 0.15s ease;
}

.contacts-radio:checked {
  border-color: var(--interactive-default);
}

.contacts-radio:checked::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--interactive-default);
}

.contacts-drawer-divider {
  height: 1px;
  background: var(--dash-border-strong);
  width: 100%;
}

.contacts-drawer-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  margin-top: 24px;
}

.contacts-reset-btn {
  width: 75px;
  height: 40px;
  border: 1px solid var(--dash-border-strong);
  border-radius: 10px;
  background: var(--dash-surface);
  color: var(--dash-text);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.contacts-reset-btn:hover {
  background: var(--surface-tertiary, #e8edec);
  border-color: var(--border-strong, #8b9996);
  color: var(--text-primary, #142624);
}

.contacts-page.dark .contacts-reset-btn:hover,
.contacts-page[data-theme="dark"] .contacts-reset-btn:hover {
  background: var(--surface-tertiary, #2b2f35);
  border-color: var(--border-strong, #69727e);
  color: var(--text-primary, #f2f3f5);
}

.contacts-apply-btn,
.contacts-apply-btn:link,
.contacts-apply-btn:visited {
  flex: 1 1;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: var(--interactive-default, #0f766e);
  color: #ffffff !important;
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease;
}

.contacts-apply-btn:hover {
  background: var(--interactive-hover, #0a655f);
  color: #ffffff !important;
}

.contacts-apply-btn:active {
  background: var(--interactive-pressed, #084f4b);
  color: #ffffff !important;
}

.contacts-page.dark .contacts-apply-btn,
.contacts-page[data-theme="dark"] .contacts-apply-btn {
  background: var(--interactive-default, #43a79c);
  color: #101113 !important;
  font-weight: 600;
}

.contacts-page.dark .contacts-apply-btn:hover,
.contacts-page[data-theme="dark"] .contacts-apply-btn:hover {
  background: var(--interactive-hover, #83c7be);
  color: #101113 !important;
}

.contacts-page.dark .contacts-apply-btn:active,
.contacts-page[data-theme="dark"] .contacts-apply-btn:active {
  background: var(--interactive-pressed, #b6ded8);
  color: #101113 !important;
}

/* --------------------------------------------------------------------------
   Confirmation Modal (Figma 1591:150817)
   -------------------------------------------------------------------------- */
.contacts-modal-scrim {
  position: fixed;
  inset: 0;
  background: rgba(14, 26, 32, 0.5);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.contacts-modal-card {
  width: 100%;
  max-width: 440px;
  background: var(--dash-surface);
  border-radius: 14px;
  box-shadow: 0px 8px 30px rgba(14, 26, 32, 0.18);
  padding: 24px;
  display: flex;
  flex-direction: column;
  position: relative;
  animation: contactsModalIn 0.18s ease-out;
}

.contacts-statement-date-range {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.contacts-date-range-dialog.MuiPaper-root {
  display: grid;
  gap: var(--space-4);
  padding: var(--space-6);
  overflow: visible;
  color: var(--text-primary);
  background: var(--surface-primary);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
}
.contacts-date-range-dialog h2 { margin: 0; font-size: var(--font-size-h4); }
.contacts-date-range-dialog p { margin: 0; color: var(--text-secondary); font-size: var(--font-size-body-sm); }
.contacts-date-range-dialog p[role="alert"] { color: var(--danger-text); }
.contacts-date-range-dialog .figma-datepicker__year-select { color-scheme: light; }
.contacts-date-range-dialog[data-theme="dark"] .figma-datepicker__year-select { color-scheme: dark; }
.contacts-date-range-dialog footer { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: var(--space-3); }
.contacts-date-range-dialog footer button {
  min-height: 40px;
  padding: var(--space-2) var(--space-4);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--text-primary);
  font: inherit;
  cursor: pointer;
}
.contacts-date-range-dialog footer button:hover { background: var(--surface-secondary); }
.contacts-date-range-dialog footer .contacts-date-range-apply {
  border-color: var(--interactive-default);
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
}
.contacts-date-range-dialog footer .contacts-date-range-apply:hover { background: var(--interactive-hover); }
.contacts-date-range-dialog footer button:focus-visible { outline: 2px solid var(--focus-ring); outline-offset: 2px; }

.contacts-statement-date-range > div {
  min-width: 0;
}

@media (max-width: 600px) {
  .contacts-statement-date-range {
    grid-template-columns: minmax(0, 1fr);
    padding-inline: 24px;
  }
}

@keyframes contactsModalIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.contacts-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}

.contacts-modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.contacts-modal-warn-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--danger-soft);
  color: var(--danger-text);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.contacts-modal-title {
  font-family: var(--font-family-primary);
  font-size: 18px;
  font-weight: 600;
  color: var(--dash-text);
  margin: 0;
}

.contacts-modal-close {
  border: none;
  background: transparent;
  color: var(--dash-tertiary);
  cursor: pointer;
  padding: 4px;
  font-size: 18px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contacts-modal-close:hover {
  background: var(--dash-surface-2);
  color: var(--dash-text);
}

.contacts-modal-body {
  font-family: var(--font-family-primary);
  font-size: 13.5px;
  line-height: 1.5;
  color: var(--dash-muted);
  margin: 0 0 24px 0;
}

.contacts-modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.contacts-modal-cancel {
  height: 40px;
  padding: 0 16px;
  border: 1px solid var(--dash-border-strong);
  border-radius: 10px;
  background: var(--dash-surface);
  color: var(--dash-text);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.contacts-modal-cancel:hover {
  background: var(--surface-tertiary, #e8edec);
  border-color: var(--border-strong, #8b9996);
  color: var(--text-primary, #142624);
}

.contacts-page.dark .contacts-modal-cancel:hover,
.contacts-page[data-theme="dark"] .contacts-modal-cancel:hover {
  background: var(--surface-tertiary, #2b2f35);
  border-color: var(--border-strong, #69727e);
  color: var(--text-primary, #f2f3f5);
}

.contacts-modal-danger {
  height: 40px;
  padding: 0 16px;
  border: none;
  border-radius: 10px;
  background: var(--danger-soft);
  color: var(--danger-text);
  font-family: var(--font-family-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.contacts-modal-danger:hover {
  background: #fde3e1;
  color: var(--danger-text);
}

.contacts-page.dark .contacts-modal-danger:hover,
.contacts-page[data-theme="dark"] .contacts-modal-danger:hover {
  background: #4a2b2c;
  color: #f3aaa4;
}

/* --------------------------------------------------------------------------
   Responsive Adaptations
   -------------------------------------------------------------------------- */
@media (max-width: 1024px) {
  .contacts-page .dashboard-main {
    margin-left: 0;
  }

  .contacts-content {
    padding: 20px 16px 36px;
  }

  .contacts-page-identity h1 {
    font-size: 28px;
    line-height: 35px;
    letter-spacing: -0.42px;
  }

  .contacts-title-row {
    flex-wrap: wrap;
  }

  .contacts-controls-row {
    flex-wrap: wrap;
  }

  .contacts-search-box {
    width: 100%;
  }
}

/* Mobile contact-flow states (Figma 1663:99514, 1663:100589). */
@media (max-width: 600px) {
  .contacts-content {
    gap: 20px;
    padding: 20px 16px 32px;
  }

  .contacts-title-row {
    align-items: flex-start;
  }

  .contacts-page-identity h1 {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.36px;
  }

  .contacts-header-actions {
    width: 100%;
  }

  .contacts-import-btn,
  .contacts-create-btn {
    flex: 1 1;
  }

  .contacts-tabs {
    overflow-x: auto;
    scrollbar-width: none;
  }

  .contacts-tabs::-webkit-scrollbar {
    display: none;
  }

  .contacts-tab {
    flex: 0 0 auto;
  }

  .contacts-controls-row {
    flex-wrap: wrap;
  }

  .contacts-search-box {
    flex: 1 1 100%;
    min-width: 0;
  }

  .contacts-filter-btn {
    flex: 0 0 44px;
    width: 44px;
    padding: 0;
    justify-content: center;
  }

  .contacts-filter-btn > span:not(.contacts-filter-badge) {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .contacts-filter-badge {
    position: absolute;
    top: -6px;
    right: -6px;
  }

  .contacts-table-card {
    border-radius: 10px;
  }

  .contacts-table-card.is-empty {
    min-height: 300px;
  }

  .contacts-empty-state {
    padding: 32px 16px;
  }

  .contacts-table-context,
  .contacts-pagination {
    padding-inline: 12px;
  }

  .contacts-filter-scrim {
    background: var(--overlay-default, rgba(0, 0, 0, 0.6));
  }

  .contacts-filter-drawer {
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-height: calc(100dvh - 64px);
    padding: 0;
    border: 0;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 24px 48px -12px rgba(14, 26, 32, 0.22),
      0 2px 6px rgba(14, 26, 32, 0.06);
    transform: translateY(100%);
    overflow: hidden;
  }

  .contacts-filter-drawer::before {
    content: "";
    width: 40px;
    height: 4px;
    margin: 8px auto;
    flex: 0 0 4px;
    border-radius: 999px;
    background: var(--dash-border);
  }

  .contacts-filter-drawer.open {
    transform: translateY(0);
  }

  .contacts-drawer-body {
    gap: 16px;
    overflow-y: auto;
    padding: 0 20px 20px;
  }

  .contacts-drawer-header {
    flex: 0 0 60px;
    margin: 0 -20px;
    padding: 0 24px;
    border-bottom: 1px solid var(--dash-border);
  }

  .contacts-drawer-title {
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: -0.08px;
  }

  .contacts-drawer-clear {
    min-height: 44px;
    padding: 0 12px;
    font-size: 13px;
    font-weight: 500;
  }

  .contacts-filter-group {
    gap: 4px;
  }

  .contacts-drawer-footer {
    flex: 0 0 88px;
    gap: 12px;
    height: 88px;
    margin: 0;
    padding: 16px 24px 28px;
    border-top: 1px solid var(--dash-border);
    background: var(--dash-surface);
  }

  .contacts-reset-btn,
  .contacts-apply-btn {
    height: 44px;
  }

  .contacts-reset-btn {
    width: 100px;
  }

  .contacts-modal-scrim {
    align-items: flex-end;
    padding: 64px 0 0;
    background: var(--overlay-default, rgba(0, 0, 0, 0.6));
    -webkit-backdrop-filter: none;
            backdrop-filter: none;
  }

  .contacts-modal-card {
    max-width: none;
    min-height: 350px;
    padding: 20px 0 0;
    border-radius: 20px 20px 0 0;
    animation: contactsSheetIn 0.2s ease-out;
  }

  .contacts-modal-card::before {
    content: "";
    position: absolute;
    top: 8px;
    left: 50%;
    width: 40px;
    height: 4px;
    border-radius: 999px;
    background: var(--dash-border);
    transform: translateX(-50%);
  }

  .contacts-modal-header {
    align-items: center;
    min-height: 60px;
    margin: 0;
    padding: 0 24px;
    border-bottom: 1px solid var(--dash-border);
  }

  .contacts-modal-title-wrap {
    gap: 12px;
  }

  .contacts-modal-warn-icon {
    width: 24px;
    height: 24px;
    border-radius: 0;
    background: transparent;
    font-size: 22px;
  }

  .contacts-modal-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: -0.08px;
  }

  .contacts-modal-body {
    min-height: 102px;
    margin: 0;
    padding: 18px 24px;
    font-size: 13px;
    line-height: 20.2px;
  }

  .contacts-modal-actions {
    flex-direction: column;
    gap: 12px;
    padding: 16px 24px 28px;
    border-top: 1px solid var(--dash-border);
  }

  .contacts-modal-cancel,
  .contacts-modal-danger {
    width: 100%;
    height: 44px;
  }

  .contacts-modal-danger {
    order: 2;
    background: transparent;
  }
}

@keyframes contactsSheetIn {
  from {
    opacity: 0;
    transform: translateY(32px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Contacts/contacts.css"],"names":[],"mappings":"AAAA;;;;;;;;;+EAS+E;;AAE/E;;+EAE+E;AAC/E;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,mDAAmD;EACnD,kDAAkD;EAClD,4CAA4C;EAC5C,oDAAoD;EACpD,yCAAyC;EACzC,4CAA4C;EAC5C,8CAA8C;EAC9C,iDAAiD;EACjD,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,iCAAiC;EACjC,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB;sBACoB;EACpB,+CAA+C;;EAE/C,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,iCAAiC;EACjC,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;+EAE+E;AAC/E;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gDAAgD;EAChD,2CAA2C;EAC3C,mCAAmC;EACnC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,YAAY;EACZ,+CAA+C;EAC/C,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,8DAA8D;EAC9D,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,4DAA4D;AAC5D;;EAEE,+CAA+C;EAC/C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;;EAEE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;EAEE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,+BAA+B;EAC/B,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;EAEE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,+BAA+B;EAC/B,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;+EAE+E;AAC/E;EACE,WAAW;EACX,+BAA+B;EAC/B,oCAAoC;EACpC,mBAAmB;EACnB,kDAAkD;EAClD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;;EAEE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,oCAAoC;EACpC,mBAAmB;EACnB,+CAA+C;EAC/C,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;+EAE+E;AAC/E;EACE,YAAY;EACZ,+BAA+B;EAC/B,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,mCAAmC;EACnC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,mDAA6D;EAC7D,2DAAqE;AACvE;;AAEA;EACE,mDAA6D;EAC7D,2DAAqE;AACvE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;;;EAME,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,SAAS;EACT,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;EAGE,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;;EAEE,gEAAgE;EAChE,mBAAmB;AACrB;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,yCAAyC;EACzC,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;EAC3B,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;EAEE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;;EAGE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;;EAEE,+CAA+C;EAC/C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;;EAEE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,+CAA+C;EAC/C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,kCAAkC;EAClC,sCAAsC;EACtC,+BAA+B;AACjC;AACA,iCAAiC,SAAS,EAAE,8BAA8B,EAAE;AAC5E,gCAAgC,SAAS,EAAE,4BAA4B,EAAE,mCAAmC,EAAE;AAC9G,8CAA8C,yBAAyB,EAAE;AACzE,6DAA6D,mBAAmB,EAAE;AAClF,gFAAgF,kBAAkB,EAAE;AACpG,qCAAqC,aAAa,EAAE,eAAe,EAAE,yBAAyB,EAAE,mBAAmB,EAAE;AACrH;EACE,gBAAgB;EAChB,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,eAAe;AACjB;AACA,kDAAkD,oCAAoC,EAAE;AACxF;EACE,wCAAwC;EACxC,sCAAsC;EACtC,oCAAoC;AACtC;AACA,sEAAsE,oCAAoC,EAAE;AAC5G,0DAA0D,oCAAoC,EAAE,mBAAmB,EAAE;;AAErH;EACE,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;IACrC,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;EAEE,4CAA4C;EAC5C,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,sDAAsD;EACxD;;EAEA;IACE,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,+BAA+B;IAC/B,UAAU;IACV,SAAS;IACT,4BAA4B;IAC5B;sCACkC;IAClC,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,2CAA2C;EAC7C;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,SAAS;IACT,YAAY;IACZ,SAAS;IACT,uBAAuB;IACvB,wCAAwC;IACxC,+BAA+B;EACjC;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,sDAAsD;IACtD,6BAAqB;YAArB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,4BAA4B;IAC5B,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,2CAA2C;EAC7C;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* ==========================================================================\n   CONTACTS PAGE — FIGMA SPEC IMPLEMENTATION\n   Figma Node ID: 1564:171361 (Contact-flow)\n   - Desktop Light: 1529:154295 (\"Maple Electrical — Contacts Filters Light\")\n   - Contacts Default: 1564:171670 (\"Maple Electrical — Contacts Light\")\n   - Filters Popover: 1529:154228 (\"Contacts Filters — Popover\")\n   - Delete Confirmation: 1591:150817\n   - Empty State: 1595:152030\n   - Search No Results: 1595:152485\n   ========================================================================== */\n\n/* --------------------------------------------------------------------------\n   Root Container & Variables\n   -------------------------------------------------------------------------- */\n.contacts-page {\n  --dash-bg: var(--bg-primary, #f4f7f7);\n  --dash-surface: var(--surface-primary, #ffffff);\n  --dash-surface-2: var(--surface-secondary, #f4f7f7);\n  --dash-surface-3: var(--surface-tertiary, #e8edec);\n  --dash-border: var(--border-subtle, #dce3e2);\n  --dash-border-strong: var(--border-default, #cdd6d4);\n  --dash-text: var(--text-primary, #142624);\n  --dash-muted: var(--text-secondary, #506360);\n  --dash-tertiary: var(--text-tertiary, #6b7b78);\n  --dash-brand: var(--interactive-default, #0f766e);\n  --interactive-default: #0f766e;\n  --interactive-hover: #0a655f;\n  --interactive-pressed: #084f4b;\n  --interactive-soft: #f0f8f7;\n  --on-interactive-primary: #ffffff;\n  --text-link: #0f766e;\n  --success-soft: #edfbf2;\n  --success-text: #115a33;\n  --danger-soft: #fef2f1;\n  --danger-text: #a3301f;\n  --font-family-primary: \"Lexend\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    Roboto, sans-serif;\n  --font-family-mono: \"JetBrains Mono\", monospace;\n\n  min-height: 100vh;\n  display: flex;\n  background: var(--dash-bg);\n  color: var(--dash-text);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  line-height: 1.4;\n  position: relative;\n}\n\n.contacts-page.dark,\n.contacts-page[data-theme=\"dark\"] {\n  --dash-bg: #101113;\n  --dash-surface: #191b1f;\n  --dash-surface-2: #22252a;\n  --dash-surface-3: #2b2f35;\n  --dash-border: #2c3036;\n  --dash-border-strong: #3a3f47;\n  --dash-text: #f2f3f5;\n  --dash-muted: #b3b8c2;\n  --dash-tertiary: #8a9896;\n  --dash-brand: #43a79c;\n  --interactive-default: #43a79c;\n  --interactive-hover: #83c7be;\n  --interactive-pressed: #b6ded8;\n  --interactive-soft: #22252a;\n  --on-interactive-primary: #101113;\n  --text-link: #83c7be;\n  --success-soft: #1b332b;\n  --success-text: #8cd2b2;\n  --danger-soft: #382324;\n  --danger-text: #f3a6a1;\n}\n\n.contacts-page *,\n.contacts-page *::before,\n.contacts-page *::after {\n  box-sizing: border-box;\n}\n\n/* --------------------------------------------------------------------------\n   Layout Shell\n   -------------------------------------------------------------------------- */\n.contacts-page .dashboard-main {\n  flex: 1;\n  min-width: 0;\n  margin-left: 256px;\n  display: flex;\n  flex-direction: column;\n}\n\n.contacts-content {\n  width: 100%;\n  min-height: calc(100vh - 64px);\n  max-width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 32px 32px 48px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* --------------------------------------------------------------------------\n   Page Header (Figma 1529:154312)\n   -------------------------------------------------------------------------- */\n.contacts-page-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.contacts-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.contacts-page-identity {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.contacts-page-identity h1 {\n  font-family: var(--font-family-primary);\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n  color: var(--dash-text);\n  margin: 0;\n}\n\n.contacts-page-identity p {\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  color: var(--dash-muted);\n  margin: 0;\n}\n\n.contacts-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.contacts-page .contacts-import-btn {\n  height: 40px;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: normal;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: all 0.15s ease;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.contacts-page .contacts-import-btn:hover {\n  background: var(--surface-tertiary, #e8edec);\n  border-color: var(--border-strong, #8b9996);\n  color: var(--text-primary, #142624);\n}\n\n.contacts-page .contacts-import-btn:focus-visible {\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: 2px;\n}\n\n.contacts-create-btn,\n.contacts-create-btn:link,\n.contacts-create-btn:visited {\n  height: 40px;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: none;\n  background: var(--interactive-default, #0f766e);\n  color: #ffffff !important;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: normal;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: background-color 0.15s ease, box-shadow 0.15s ease;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.contacts-create-btn:hover {\n  background: var(--interactive-hover, #0a655f);\n  color: #ffffff !important;\n}\n\n.contacts-create-btn:active {\n  background: var(--interactive-pressed, #084f4b);\n  color: #ffffff !important;\n}\n\n.contacts-create-btn:focus-visible {\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: 2px;\n}\n\n.contacts-create-btn svg {\n  width: 16px;\n  height: 16px;\n  font-size: 16px;\n  flex-shrink: 0;\n  stroke-width: 2.25;\n  color: #ffffff !important;\n  stroke: #ffffff !important;\n  fill: none;\n}\n\n/* Dark mode styling matching Quotations and Project Theme */\n.contacts-page.dark .contacts-create-btn,\n.contacts-page[data-theme=\"dark\"] .contacts-create-btn {\n  background: var(--interactive-default, #43a79c);\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n.contacts-page.dark .contacts-create-btn svg,\n.contacts-page[data-theme=\"dark\"] .contacts-create-btn svg {\n  color: #101113 !important;\n  stroke: #101113 !important;\n}\n\n.contacts-page.dark .contacts-create-btn:hover,\n.contacts-page[data-theme=\"dark\"] .contacts-create-btn:hover {\n  background: var(--interactive-hover, #83c7be);\n  color: #101113 !important;\n}\n\n.contacts-page.dark .contacts-create-btn:active,\n.contacts-page[data-theme=\"dark\"] .contacts-create-btn:active {\n  background: var(--interactive-pressed, #b6ded8);\n  color: #101113 !important;\n}\n\n.contacts-page.dark .contacts-import-btn {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.contacts-page.dark .contacts-import-btn:hover,\n.contacts-page[data-theme=\"dark\"] .contacts-import-btn:hover {\n  background: var(--surface-tertiary, #2b2f35);\n  border-color: var(--border-strong, #69727e);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.contacts-statement-btn {\n  height: 40px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid var(--dash-border-strong);\n  background: var(--dash-surface);\n  color: var(--dash-text);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.15s ease;\n}\n\n.contacts-statement-btn:hover {\n  background: var(--surface-tertiary, #e8edec);\n  border-color: var(--border-strong, #8b9996);\n  color: var(--text-primary, #142624);\n}\n\n.contacts-page.dark .contacts-statement-btn:hover,\n.contacts-page[data-theme=\"dark\"] .contacts-statement-btn:hover {\n  background: var(--surface-tertiary, #2b2f35);\n  border-color: var(--border-strong, #69727e);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.contacts-statement-btn.active {\n  background: var(--interactive-soft);\n  color: var(--text-link);\n  border-color: var(--interactive-default);\n}\n\n/* --------------------------------------------------------------------------\n   Contact Filters & Tabs (Figma 1529:154321)\n   -------------------------------------------------------------------------- */\n.contacts-filter-section {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: 16px;\n  min-height: 0;\n}\n\n.contacts-tabs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-bottom: 1px solid var(--dash-border);\n  width: 100%;\n}\n\n.contacts-tab {\n  height: 40px;\n  padding: 0 12px;\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--dash-muted);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: -1px;\n  transition: all 0.15s ease;\n}\n\n.contacts-tab:hover {\n  color: var(--dash-text);\n}\n\n.contacts-tab.active {\n  color: var(--text-link);\n  border-bottom-color: var(--interactive-default);\n}\n\n/* --------------------------------------------------------------------------\n   Search & Filter Controls Row (Figma 1529:154329)\n   -------------------------------------------------------------------------- */\n.contacts-controls-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  width: 100%;\n}\n\n.contacts-controls-row .contacts-register-filter {\n  flex: 0 0 auto;\n  width: max-content;\n  max-width: 100%;\n}\n\n.contacts-controls-row .contacts-clear-filters {\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.contacts-search-box {\n  width: 320px;\n  height: 40px;\n  border-radius: 10px;\n  border: 1px solid var(--dash-border);\n  background: var(--dash-surface);\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  gap: 8px;\n  transition: border-color 0.15s ease;\n}\n\n.contacts-search-box:focus-within {\n  border-color: var(--interactive-default);\n}\n\n.contacts-search-icon {\n  font-size: 16px;\n  color: var(--dash-tertiary);\n  flex-shrink: 0;\n}\n\n.contacts-search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: var(--font-family-primary);\n  font-size: 14px;\n  color: var(--dash-text);\n}\n\n.contacts-search-input::placeholder {\n  color: var(--dash-tertiary);\n}\n\n.contacts-search-clear {\n  border: none;\n  background: transparent;\n  color: var(--dash-tertiary);\n  cursor: pointer;\n  padding: 2px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.contacts-search-clear:hover {\n  color: var(--dash-text);\n}\n\n.contacts-filter-btn {\n  height: 40px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid var(--dash-border-strong);\n  background: var(--dash-surface);\n  color: var(--dash-text);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.15s ease;\n  position: relative;\n}\n\n.contacts-filter-btn:hover {\n  background: var(--dash-surface-2);\n  border-color: var(--dash-muted);\n}\n\n.contacts-filter-btn.active {\n  border-color: var(--interactive-default);\n  color: var(--text-link);\n  background: var(--interactive-soft);\n}\n\n.contacts-filter-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: var(--interactive-default);\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 600;\n  margin-left: 2px;\n}\n\n/* --------------------------------------------------------------------------\n   Contacts Table Card (Figma 1529:154332)\n   -------------------------------------------------------------------------- */\n.contacts-table-card {\n  width: 100%;\n  background: var(--dash-surface);\n  border: 1px solid var(--dash-border);\n  border-radius: 14px;\n  box-shadow: 0px 1px 2px 0px rgba(14, 26, 32, 0.06);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.contacts-table-card.is-empty {\n  flex: 1;\n  min-height: 320px;\n}\n\n.contacts-table-context {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  border-bottom: 1px solid var(--dash-border);\n}\n\n.contacts-table-count {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.065px;\n  color: var(--dash-text);\n}\n\n.contacts-table-scope {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--dash-muted);\n}\n\n.contacts-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.contacts-table {\n  width: 100%;\n  min-width: 1050px;\n  border-collapse: collapse;\n  table-layout: fixed;\n  text-align: left;\n}\n\n/* Table Headings */\n.contacts-thead tr {\n  height: 44px;\n  background: var(--dash-surface-2);\n  border-bottom: 1px solid var(--dash-border);\n}\n\n.contacts-th {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.065px;\n  color: var(--dash-muted);\n  padding: 0 12px;\n  white-space: nowrap;\n}\n\n.contacts-th.th-name {\n  width: 32%;\n  min-width: 220px;\n}\n\n.contacts-th.th-contact {\n  width: 26%;\n  min-width: 200px;\n}\n\n.contacts-th.th-abn {\n  width: 146px;\n  min-width: 130px;\n}\n\n.contacts-th.th-terms {\n  width: 100px;\n  min-width: 90px;\n}\n\n.contacts-th.th-reminders {\n  width: 96px;\n  min-width: 90px;\n}\n\n.contacts-th.th-balance {\n  width: 140px;\n  min-width: 120px;\n  text-align: right;\n}\n\n.contacts-th.th-actions,\n.contacts-td.td-actions {\n  width: 64px;\n  min-width: 64px;\n  max-width: 64px;\n  text-align: center;\n  padding: 0 8px;\n}\n\n/* Table Rows */\n.contacts-tbody tr {\n  height: 64px;\n  border-bottom: 1px solid var(--dash-border);\n  transition: background-color 0.15s ease;\n}\n\n.contacts-tbody tr:hover {\n  background-color: var(--dash-surface-2);\n}\n\n.contacts-tbody .app-skeleton-tr td {\n  padding: 8px 12px;\n  vertical-align: middle;\n}\n\n.contacts-clickable-row {\n  cursor: pointer;\n}\n\n.contacts-clickable-row:focus-visible {\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: -2px;\n}\n\n.contacts-td {\n  padding: 8px 12px;\n  vertical-align: middle;\n}\n\n/* Name Cell */\n.contacts-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.contacts-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 12px;\n  background: var(--interactive-soft);\n  border: 1.5px solid var(--dash-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-family: var(--font-family-primary);\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--interactive-default);\n  text-transform: uppercase;\n}\n\n.contacts-name-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.contacts-company-link {\n  text-decoration: none;\n  color: inherit;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.contacts-company-link:hover .contacts-company-name {\n  color: var(--interactive-default, #0f766e);\n  text-decoration: underline;\n}\n\n.contacts-company-name {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--dash-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: color 0.15s ease;\n}\n\n.contacts-type-sub {\n  font-family: var(--font-family-primary);\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--dash-muted);\n}\n\n/* Contact Person Cell */\n.contacts-contact-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.contacts-contact-name {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--dash-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.contacts-contact-email {\n  font-family: var(--font-family-primary);\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--dash-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ABN & Terms */\n.contacts-abn-text,\n.contacts-terms-text {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--dash-text);\n  white-space: nowrap;\n}\n\n/* Reminder Status Pill */\n.contacts-reminder-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-family: var(--font-family-primary);\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.11px;\n}\n\n.contacts-reminder-pill.pill-on {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n\n.contacts-reminder-pill.pill-off {\n  background: var(--danger-soft);\n  color: var(--danger-text);\n}\n\n/* Open Balance */\n.contacts-balance-cell {\n  font-family: var(--font-family-mono);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--dash-text);\n  text-align: right;\n  white-space: nowrap;\n}\n\n/* Actions Menu */\n.contacts-actions-cell {\n  text-align: center;\n  position: relative;\n}\n\n.contacts-action-trigger {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  color: var(--dash-muted);\n  border-radius: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.contacts-action-trigger:hover {\n  background: var(--dash-surface-2);\n  color: var(--dash-text);\n}\n\n.contacts-menu-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  z-index: 100;\n  min-width: 160px;\n  background: var(--dash-surface);\n  border: 1px solid var(--dash-border);\n  border-radius: 10px;\n  box-shadow: 0px 4px 12px rgba(14, 26, 32, 0.12);\n  padding: 4px;\n  display: flex;\n  flex-direction: column;\n}\n\n.contacts-menu-item {\n  width: 100%;\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  color: var(--dash-text);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  text-align: left;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background-color 0.1s ease;\n  text-decoration: none;\n}\n\n.contacts-menu-item:hover {\n  background: var(--dash-surface-2);\n}\n\n.contacts-menu-item.delete {\n  color: var(--danger-text);\n}\n\n.contacts-menu-item.delete:hover {\n  background: var(--danger-soft);\n}\n\n/* --------------------------------------------------------------------------\n   Table Pagination (Figma 1529:154479)\n   -------------------------------------------------------------------------- */\n.contacts-pagination {\n  height: 52px;\n  background: var(--dash-surface);\n  border-top: 1px solid var(--dash-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n}\n\n.contacts-pagination-info {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  color: var(--dash-muted);\n}\n\n.contacts-pagination.is-loading {\n  visibility: hidden;\n}\n\n.contacts-pagination-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.contacts-page-btn {\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--dash-border-strong);\n  border-radius: 6px;\n  background: var(--dash-surface);\n  color: var(--dash-text);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.contacts-page-btn:hover:not(:disabled) {\n  background: var(--dash-surface-2);\n  border-color: var(--dash-muted);\n}\n\n.contacts-page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* --------------------------------------------------------------------------\n   Empty & Search No Results States (Figma 1595:152030 & 1595:152485)\n   -------------------------------------------------------------------------- */\n.contacts-empty-state {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  padding: 32px;\n  text-align: center;\n}\n\n.contacts-empty-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: var(--radius-full, 9999px);\n  background: var(--interactive-soft);\n  color: var(--interactive-default);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 60px;\n  overflow: hidden;\n}\n\n.contacts-empty-state--noResults .contacts-empty-icon {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-tertiary, #6b7b78);\n}\n\n.contacts-empty-icon__asset {\n  width: 36px;\n  height: 36px;\n  background-color: currentColor;\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: 36px 36px;\n  -webkit-mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-size: 36px 36px;\n}\n\n.contacts-empty-icon__asset.is-plus {\n  mask-image: url(\"../../assets/icons/contacts/empty-plus.svg\");\n  -webkit-mask-image: url(\"../../assets/icons/contacts/empty-plus.svg\");\n}\n\n.contacts-empty-icon__asset.is-file {\n  mask-image: url(\"../../assets/icons/contacts/empty-file.svg\");\n  -webkit-mask-image: url(\"../../assets/icons/contacts/empty-file.svg\");\n}\n\n.contacts-empty-copy {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  width: min(280px, 100%);\n}\n\n.contacts-empty-title {\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 500;\n  line-height: normal;\n  color: var(--dash-text);\n  width: 100%;\n  margin: 0;\n}\n\n.contacts-empty-desc {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: var(--dash-muted);\n  width: 100%;\n  margin: 0;\n}\n\n.contacts-empty-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  overflow: hidden;\n}\n\n.contacts-empty-primary,\n.contacts-empty-primary:link,\n.contacts-empty-primary:visited,\n.contacts-empty-secondary,\n.contacts-empty-secondary:link,\n.contacts-empty-secondary:visited {\n  height: 32px;\n  padding: 0 12px;\n  border-radius: var(--radius-md, 10px);\n  border: 0;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: normal;\n  text-decoration: none;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contacts-empty-primary,\n.contacts-empty-primary:link,\n.contacts-empty-primary:visited {\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary) !important;\n}\n\n.contacts-empty-primary:hover {\n  background: var(--interactive-hover);\n  color: var(--on-interactive-primary) !important;\n}\n\n.contacts-empty-primary:active {\n  background: var(--interactive-pressed);\n}\n\n.contacts-empty-secondary,\n.contacts-empty-secondary:link,\n.contacts-empty-secondary:visited {\n  background: transparent;\n  color: var(--interactive-default);\n}\n\n.contacts-empty-secondary:hover {\n  background: var(--interactive-soft);\n  color: var(--interactive-hover);\n}\n\n.contacts-empty-primary:focus-visible,\n.contacts-empty-secondary:focus-visible {\n  outline: 2px solid var(--focus-ring, var(--interactive-default));\n  outline-offset: 2px;\n}\n\n/* --------------------------------------------------------------------------\n   Filters Drawer / Popover (Figma 1529:154228)\n   -------------------------------------------------------------------------- */\n.contacts-filter-scrim {\n  position: fixed;\n  inset: 0;\n  background: rgba(14, 26, 32, 0.4);\n  z-index: 998;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n.contacts-filter-scrim.open {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.contacts-filter-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 320px;\n  background: var(--dash-surface);\n  border-left: 1px solid var(--dash-border);\n  box-shadow: -4px 0 24px rgba(14, 26, 32, 0.1);\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 24px 20px;\n  transform: translateX(100%);\n  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  overflow-y: auto;\n}\n\n.contacts-filter-drawer.open {\n  transform: translateX(0);\n}\n\n.contacts-controls-row .contacts-register-filter .quotation-figma-dropdown-trigger {\n  box-sizing: border-box;\n  height: 40px;\n  border-width: 1px;\n  padding: 0 12px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.contacts-page > .catalogue-modal-menu-popper .quotation-figma-dropdown-option {\n  height: auto;\n  min-height: 36px;\n  padding: 8px 10px;\n  text-align: left;\n  font: 400 13px/20px var(--font-family-primary);\n}\n\n.contacts-filter-drawer .quotation-clear-filters-btn {\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.contacts-drawer-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.contacts-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 40px;\n}\n\n.contacts-drawer-title {\n  font-family: var(--font-family-primary);\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: -0.22px;\n  color: var(--dash-text);\n  margin: 0;\n}\n\n.contacts-drawer-clear {\n  border: none;\n  background: transparent;\n  color: var(--text-link);\n  font-family: var(--font-family-primary);\n  font-size: 12px;\n  font-weight: 400;\n  cursor: pointer;\n  padding: 0;\n}\n\n.contacts-drawer-clear:hover {\n  text-decoration: underline;\n}\n\n.contacts-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.contacts-group-title {\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.07px;\n  color: var(--dash-text);\n  margin: 0;\n}\n\n.contacts-radio-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 24px;\n  cursor: pointer;\n  font-family: var(--font-family-primary);\n  font-size: 12px;\n  color: var(--dash-text);\n  user-select: none;\n}\n\n.contacts-radio {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 14px;\n  height: 14px;\n  border: 1.5px solid var(--dash-border-strong);\n  border-radius: 50%;\n  outline: none;\n  cursor: pointer;\n  display: grid;\n  place-content: center;\n  background-color: var(--dash-surface);\n  transition: all 0.15s ease;\n}\n\n.contacts-radio:checked {\n  border-color: var(--interactive-default);\n}\n\n.contacts-radio:checked::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--interactive-default);\n}\n\n.contacts-drawer-divider {\n  height: 1px;\n  background: var(--dash-border-strong);\n  width: 100%;\n}\n\n.contacts-drawer-footer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  margin-top: 24px;\n}\n\n.contacts-reset-btn {\n  width: 75px;\n  height: 40px;\n  border: 1px solid var(--dash-border-strong);\n  border-radius: 10px;\n  background: var(--dash-surface);\n  color: var(--dash-text);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.contacts-reset-btn:hover {\n  background: var(--surface-tertiary, #e8edec);\n  border-color: var(--border-strong, #8b9996);\n  color: var(--text-primary, #142624);\n}\n\n.contacts-page.dark .contacts-reset-btn:hover,\n.contacts-page[data-theme=\"dark\"] .contacts-reset-btn:hover {\n  background: var(--surface-tertiary, #2b2f35);\n  border-color: var(--border-strong, #69727e);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.contacts-apply-btn,\n.contacts-apply-btn:link,\n.contacts-apply-btn:visited {\n  flex: 1;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  background: var(--interactive-default, #0f766e);\n  color: #ffffff !important;\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.15s ease;\n}\n\n.contacts-apply-btn:hover {\n  background: var(--interactive-hover, #0a655f);\n  color: #ffffff !important;\n}\n\n.contacts-apply-btn:active {\n  background: var(--interactive-pressed, #084f4b);\n  color: #ffffff !important;\n}\n\n.contacts-page.dark .contacts-apply-btn,\n.contacts-page[data-theme=\"dark\"] .contacts-apply-btn {\n  background: var(--interactive-default, #43a79c);\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n.contacts-page.dark .contacts-apply-btn:hover,\n.contacts-page[data-theme=\"dark\"] .contacts-apply-btn:hover {\n  background: var(--interactive-hover, #83c7be);\n  color: #101113 !important;\n}\n\n.contacts-page.dark .contacts-apply-btn:active,\n.contacts-page[data-theme=\"dark\"] .contacts-apply-btn:active {\n  background: var(--interactive-pressed, #b6ded8);\n  color: #101113 !important;\n}\n\n/* --------------------------------------------------------------------------\n   Confirmation Modal (Figma 1591:150817)\n   -------------------------------------------------------------------------- */\n.contacts-modal-scrim {\n  position: fixed;\n  inset: 0;\n  background: rgba(14, 26, 32, 0.5);\n  backdrop-filter: blur(2px);\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.contacts-modal-card {\n  width: 100%;\n  max-width: 440px;\n  background: var(--dash-surface);\n  border-radius: 14px;\n  box-shadow: 0px 8px 30px rgba(14, 26, 32, 0.18);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  animation: contactsModalIn 0.18s ease-out;\n}\n\n.contacts-statement-date-range {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.contacts-date-range-dialog.MuiPaper-root {\n  display: grid;\n  gap: var(--space-4);\n  padding: var(--space-6);\n  overflow: visible;\n  color: var(--text-primary);\n  background: var(--surface-primary);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n}\n.contacts-date-range-dialog h2 { margin: 0; font-size: var(--font-size-h4); }\n.contacts-date-range-dialog p { margin: 0; color: var(--text-secondary); font-size: var(--font-size-body-sm); }\n.contacts-date-range-dialog p[role=\"alert\"] { color: var(--danger-text); }\n.contacts-date-range-dialog .figma-datepicker__year-select { color-scheme: light; }\n.contacts-date-range-dialog[data-theme=\"dark\"] .figma-datepicker__year-select { color-scheme: dark; }\n.contacts-date-range-dialog footer { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: var(--space-3); }\n.contacts-date-range-dialog footer button {\n  min-height: 40px;\n  padding: var(--space-2) var(--space-4);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: inherit;\n  cursor: pointer;\n}\n.contacts-date-range-dialog footer button:hover { background: var(--surface-secondary); }\n.contacts-date-range-dialog footer .contacts-date-range-apply {\n  border-color: var(--interactive-default);\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n}\n.contacts-date-range-dialog footer .contacts-date-range-apply:hover { background: var(--interactive-hover); }\n.contacts-date-range-dialog footer button:focus-visible { outline: 2px solid var(--focus-ring); outline-offset: 2px; }\n\n.contacts-statement-date-range > div {\n  min-width: 0;\n}\n\n@media (max-width: 600px) {\n  .contacts-statement-date-range {\n    grid-template-columns: minmax(0, 1fr);\n    padding-inline: 24px;\n  }\n}\n\n@keyframes contactsModalIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.contacts-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.contacts-modal-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.contacts-modal-warn-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--danger-soft);\n  color: var(--danger-text);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.contacts-modal-title {\n  font-family: var(--font-family-primary);\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--dash-text);\n  margin: 0;\n}\n\n.contacts-modal-close {\n  border: none;\n  background: transparent;\n  color: var(--dash-tertiary);\n  cursor: pointer;\n  padding: 4px;\n  font-size: 18px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contacts-modal-close:hover {\n  background: var(--dash-surface-2);\n  color: var(--dash-text);\n}\n\n.contacts-modal-body {\n  font-family: var(--font-family-primary);\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: var(--dash-muted);\n  margin: 0 0 24px 0;\n}\n\n.contacts-modal-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.contacts-modal-cancel {\n  height: 40px;\n  padding: 0 16px;\n  border: 1px solid var(--dash-border-strong);\n  border-radius: 10px;\n  background: var(--dash-surface);\n  color: var(--dash-text);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.contacts-modal-cancel:hover {\n  background: var(--surface-tertiary, #e8edec);\n  border-color: var(--border-strong, #8b9996);\n  color: var(--text-primary, #142624);\n}\n\n.contacts-page.dark .contacts-modal-cancel:hover,\n.contacts-page[data-theme=\"dark\"] .contacts-modal-cancel:hover {\n  background: var(--surface-tertiary, #2b2f35);\n  border-color: var(--border-strong, #69727e);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.contacts-modal-danger {\n  height: 40px;\n  padding: 0 16px;\n  border: none;\n  border-radius: 10px;\n  background: var(--danger-soft);\n  color: var(--danger-text);\n  font-family: var(--font-family-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.contacts-modal-danger:hover {\n  background: #fde3e1;\n  color: var(--danger-text);\n}\n\n.contacts-page.dark .contacts-modal-danger:hover,\n.contacts-page[data-theme=\"dark\"] .contacts-modal-danger:hover {\n  background: #4a2b2c;\n  color: #f3aaa4;\n}\n\n/* --------------------------------------------------------------------------\n   Responsive Adaptations\n   -------------------------------------------------------------------------- */\n@media (max-width: 1024px) {\n  .contacts-page .dashboard-main {\n    margin-left: 0;\n  }\n\n  .contacts-content {\n    padding: 20px 16px 36px;\n  }\n\n  .contacts-page-identity h1 {\n    font-size: 28px;\n    line-height: 35px;\n    letter-spacing: -0.42px;\n  }\n\n  .contacts-title-row {\n    flex-wrap: wrap;\n  }\n\n  .contacts-controls-row {\n    flex-wrap: wrap;\n  }\n\n  .contacts-search-box {\n    width: 100%;\n  }\n}\n\n/* Mobile contact-flow states (Figma 1663:99514, 1663:100589). */\n@media (max-width: 600px) {\n  .contacts-content {\n    gap: 20px;\n    padding: 20px 16px 32px;\n  }\n\n  .contacts-title-row {\n    align-items: flex-start;\n  }\n\n  .contacts-page-identity h1 {\n    font-size: 24px;\n    line-height: 30px;\n    letter-spacing: -0.36px;\n  }\n\n  .contacts-header-actions {\n    width: 100%;\n  }\n\n  .contacts-import-btn,\n  .contacts-create-btn {\n    flex: 1;\n  }\n\n  .contacts-tabs {\n    overflow-x: auto;\n    scrollbar-width: none;\n  }\n\n  .contacts-tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .contacts-tab {\n    flex: 0 0 auto;\n  }\n\n  .contacts-controls-row {\n    flex-wrap: wrap;\n  }\n\n  .contacts-search-box {\n    flex: 1 1 100%;\n    min-width: 0;\n  }\n\n  .contacts-filter-btn {\n    flex: 0 0 44px;\n    width: 44px;\n    padding: 0;\n    justify-content: center;\n  }\n\n  .contacts-filter-btn > span:not(.contacts-filter-badge) {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n\n  .contacts-filter-badge {\n    position: absolute;\n    top: -6px;\n    right: -6px;\n  }\n\n  .contacts-table-card {\n    border-radius: 10px;\n  }\n\n  .contacts-table-card.is-empty {\n    min-height: 300px;\n  }\n\n  .contacts-empty-state {\n    padding: 32px 16px;\n  }\n\n  .contacts-table-context,\n  .contacts-pagination {\n    padding-inline: 12px;\n  }\n\n  .contacts-filter-scrim {\n    background: var(--overlay-default, rgba(0, 0, 0, 0.6));\n  }\n\n  .contacts-filter-drawer {\n    top: auto;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    max-height: calc(100dvh - 64px);\n    padding: 0;\n    border: 0;\n    border-radius: 20px 20px 0 0;\n    box-shadow: 0 24px 48px -12px rgba(14, 26, 32, 0.22),\n      0 2px 6px rgba(14, 26, 32, 0.06);\n    transform: translateY(100%);\n    overflow: hidden;\n  }\n\n  .contacts-filter-drawer::before {\n    content: \"\";\n    width: 40px;\n    height: 4px;\n    margin: 8px auto;\n    flex: 0 0 4px;\n    border-radius: 999px;\n    background: var(--dash-border);\n  }\n\n  .contacts-filter-drawer.open {\n    transform: translateY(0);\n  }\n\n  .contacts-drawer-body {\n    gap: 16px;\n    overflow-y: auto;\n    padding: 0 20px 20px;\n  }\n\n  .contacts-drawer-header {\n    flex: 0 0 60px;\n    margin: 0 -20px;\n    padding: 0 24px;\n    border-bottom: 1px solid var(--dash-border);\n  }\n\n  .contacts-drawer-title {\n    font-size: 16px;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n  }\n\n  .contacts-drawer-clear {\n    min-height: 44px;\n    padding: 0 12px;\n    font-size: 13px;\n    font-weight: 500;\n  }\n\n  .contacts-filter-group {\n    gap: 4px;\n  }\n\n  .contacts-drawer-footer {\n    flex: 0 0 88px;\n    gap: 12px;\n    height: 88px;\n    margin: 0;\n    padding: 16px 24px 28px;\n    border-top: 1px solid var(--dash-border);\n    background: var(--dash-surface);\n  }\n\n  .contacts-reset-btn,\n  .contacts-apply-btn {\n    height: 44px;\n  }\n\n  .contacts-reset-btn {\n    width: 100px;\n  }\n\n  .contacts-modal-scrim {\n    align-items: flex-end;\n    padding: 64px 0 0;\n    background: var(--overlay-default, rgba(0, 0, 0, 0.6));\n    backdrop-filter: none;\n  }\n\n  .contacts-modal-card {\n    max-width: none;\n    min-height: 350px;\n    padding: 20px 0 0;\n    border-radius: 20px 20px 0 0;\n    animation: contactsSheetIn 0.2s ease-out;\n  }\n\n  .contacts-modal-card::before {\n    content: \"\";\n    position: absolute;\n    top: 8px;\n    left: 50%;\n    width: 40px;\n    height: 4px;\n    border-radius: 999px;\n    background: var(--dash-border);\n    transform: translateX(-50%);\n  }\n\n  .contacts-modal-header {\n    align-items: center;\n    min-height: 60px;\n    margin: 0;\n    padding: 0 24px;\n    border-bottom: 1px solid var(--dash-border);\n  }\n\n  .contacts-modal-title-wrap {\n    gap: 12px;\n  }\n\n  .contacts-modal-warn-icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 0;\n    background: transparent;\n    font-size: 22px;\n  }\n\n  .contacts-modal-title {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n  }\n\n  .contacts-modal-body {\n    min-height: 102px;\n    margin: 0;\n    padding: 18px 24px;\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n\n  .contacts-modal-actions {\n    flex-direction: column;\n    gap: 12px;\n    padding: 16px 24px 28px;\n    border-top: 1px solid var(--dash-border);\n  }\n\n  .contacts-modal-cancel,\n  .contacts-modal-danger {\n    width: 100%;\n    height: 44px;\n  }\n\n  .contacts-modal-danger {\n    order: 2;\n    background: transparent;\n  }\n}\n\n@keyframes contactsSheetIn {\n  from {\n    opacity: 0;\n    transform: translateY(32px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
